module.exports = __webpack_public_path__ + "static/media/claude.b848581a.svg";